export default "__VITE_ASSET__BPBiXypC__"